const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const logoutUser = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/logout/`, // your logout endpoint
      {
        method: "POST", // change if your API uses GET
        headers: getHeaders(),
      }
    );

    const data = await response.json();

    // Clear frontend storage even if API fails
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");

    if (!response.ok) {
      throw new Error(data.error || "Logout failed");
    }

    return data;
  } catch (error) {
    // Still clear storage
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");

    throw error;
  }
};